import {
  SpravaOUcastiVerejnostiFormData,
} from '../model/sprievodnyDokument/spravaoUcastiVerejnosti/SpravaOUcastiVerejnostiFormData';

const initFormData = (): SpravaOUcastiVerejnostiFormData => ({
  informovanie: false,
  prerokovanie: false,
  odovodnenieZapojenieVerejnosti: '',

  predbeznaInformacia: false,
  legislativnyZamer: false,
  ineSposobInformovaniaVerejnosti: false,
  ineSposobInformovaniaVerejnostiText: '',

  oprobleme: false,
  osposobeZapojenia: false,
  ocasovomRamci: false,
  oprocese: false,
  osposobeNalozenia: false,
  ineInformacieVerejnosti: false,
  ineInformacieVerejnostiText: '',

  formaOsobne: false,
  formaUstne: false,
  formaPisomne: false,
  formaIne: false,
  formaIneText: '',
  formaOdovodnenie: '',

  pracovnaSkupina: false,
  konferencia: false,
  diskusiaKLegislativnemuProcesu: false,
  konzultacia: false,
  pripomienkovanie: false,
  inePrerokovanieVerejnostou: false,
  inePrerokovanieVerejnostouText: '',

  vyzvane: {
    zaujmoveZdruzenia: undefined,
    podnikatelia: undefined,
    mimovladneANeziskoveOrg: undefined,
    akademickaAVedeckaObec: undefined,
    cirkvi: undefined,
    ine: undefined,
    ineText: '',
  },
  vyzvaneOdovodnenie: '',

  zucastnene: {
    zaujmoveZdruzenia: undefined,
    podnikatelia: undefined,
    mimovladneANeziskoveOrg: undefined,
    akademickaAVedeckaObec: undefined,
    cirkvi: undefined,
    ine: undefined,
    ineText: '',
  },

  prejaviliZaujem: {
    zaujmoveZdruzenia: undefined,
    podnikatelia: undefined,
    mimovladneANeziskoveOrg: undefined,
    akademickaAVedeckaObec: undefined,
    cirkvi: undefined,
    ine: undefined,
    ineText: '',
  },

  iniciativneZucastnene: {
    zaujmoveZdruzenia: undefined,
    podnikatelia: undefined,
    mimovladneANeziskoveOrg: undefined,
    akademickaAVedeckaObec: undefined,
    cirkvi: undefined,
    ine: undefined,
    ineText: '',
  },

  organyVerejnejSpravy: undefined,
  zaujmoveZdruzenia: undefined,
  podnikatelia: undefined,
  mimovladneANeziskoveOrg: undefined,
  akademickaAVedeckaObec: undefined,
  cirkvi: undefined,
  ine: undefined,
  ineText: '',
  sposobNalozeniaOdovodnenie: '',
  vyhodnotenieUcastiOdovodnenie: '',
});

export default initFormData;
